<template>
  <div>
    <div v-if="modifier.AdditionGroupId == comboDealAdditions.combogroupid">
      <div class="flex mt-4">
        <div class="w-1/2">
          <p class="text-md font-bold text-product-gray">
            {{ modifierGroup[`name_${language}`] }}
          </p>
        </div>

        <div class="w-1/2 text-right">
          <p v-if="modifierGroup.minSelectedAmount" class="text-xs">
            {{ lang["minimum_addition_selection"][language] }}:
            {{ modifierGroup.minSelectedAmount }}
          </p>
          <p v-if="modifierGroup.maxSelectedAmount > 0" class="text-xs">
            {{ lang["maximum_addition_selection"][language] }}:
            {{ modifierGroup.maxSelectedAmount }}
          </p>
        </div>
      </div>

      <div
        :class="[
          'border-t-1 border-l-1 border-r-1 rounded-xl mt-2 border-border-gray borderlastChild',
          modifierGroup.Additions.length > 5 && CurrentTheme == 'default'
            ? 'scrollbar-thumb-primary'
            : 'scrollbar-thumb-new-primary',
        ]"
      >
        <label
          :class="['borderNone borderlastChild ']"
          v-for="(addition, index) in modifierGroup.Additions"
          :key="addition.Id"
        >
          <div>
            <input
              @click="
                giveComboDealId(index, groupIndex);
                selectModifier(
                  modifierGroup.AdditionGroupId,
                  addition.price,
                  addition.Id,
                  { modifierGroup, addition }
                );
                modifierGroup.maxSelectedAmount == 1 &&
                  uncheck($event, addition.Id, addition.price);
              "
              class="input mr-2 hidden w-full leading-tight"
              :type="modifierGroup.maxSelectedAmount == 1 ? 'radio' : 'checkbox'"
              :value="addition"
              :name="modifierGroup[`name_${language}`]"

            />
            <div
              :class="[
                'pr-4 py-2 borderAndRadius flex justify-between p-2 pl-6 border-b-1 border-border-gray transition duration-300',
                hasKiosk ? 'h-16 items-center' : '',
              ]"
              :style="
                isAlreadySelected(addition)
                  ? listsActiveBackground
                  : listsBackground
              "
            >
              <div :class="['w-1/2 items-center flex']">
                <div class="block">
                  <span
                    :class="[
                      'font-semibold',
                      { active: isActive }
                    ]"
                    :style="
                      isAlreadySelected(addition)
                        ? listsActiveText
                        : listsText
                    "
                    >{{ addition[`name_${language}`] }}</span
                  >
                </div>
              </div>

              <div class="flex">
                <div>
                  <label v-if="addition.price > 0">
                    <input
                      @click="
                          selectModifier(
                            modifierGroup.AdditionGroupId,
                            addition.price,
                            addition.Id,
                            { modifierGroup, addition }
                          );
                          modifierGroup.maxSelectedAmount == 1 &&
                            uncheck($event, addition.Id, addition.price, {
                              modifierGroup,
                              addition,
                            });
                        "
                      class="input mr-2 hidden leading-tight"
                      :type="
                        modifierGroup.maxSelectedAmount == 1 ? 'radio' : 'checkbox'
                      "
                      :value="addition"
                      :name="modifierGroup[`name_${language}`]"
                    />
                    <span
                      :class="[
                        'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked extra checkedPrice',
                        disableBackground,
                      ]"
                      :style="
                        isAlreadySelected(addition)
                          ? listActivePrice 
                          : '' 
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="h-4 w-4"
                      >
                        <path
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          fill="none"
                          :stroke="selectItemColor"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <p
                        v-if="addition.price > 0"
                        class="ml-2 pr-1 text-sm font-semibold"
                        :style="
                          isAlreadySelected(addition)
                            ? listActivePriceText
                            : listsActiveText
                        "
                      >
                        {{ currency }} {{ addition.price }}
                      </p>
                    </span>
                  </label>
                  <span
                    v-if="!addition.price"
                    :class="[
                      'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked2',
                      disableBackground,
                    ]"
                    :style="
                      isAlreadySelected(addition)
                        ? listActivePrice
                        : ''
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      class="h-4 w-4"
                    >
                      <path
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        fill="none"
                        :stroke="selectItemColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import _ from "lodash";
export default {
  props: {
    modifier: {
      type: Object,
      required: true,
    },
    modifierGroup: {
      type: Object,
      default: () => {},
    },
    allSelectedModifiers: {
      type: Array,
      default: () => [],
    },
    minModifierComboCount: Number,
    groupIndex: Number,
    selectedModifiersGroupIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lodash: _,
      lang: lang,
      selectedModifiers: [],
      selectedComboModifiers: {},
      comboDealIndex: 0,
      comboGroupDealIndex: 0,
      // used for saving additions and using them for editing an cart item
      selectedAdditions: [],

      // Temporary to keep the Ids to match with the theme.
      selectedModifiersArray: [],
      disableModifiers: false,
      modifiersMessage: "",
      disableBackground: "",
      isActive: false,
      CurrentTheme: localStorage.getItem("theme"),
      previeusAdditionPrice: 0,
      previeusAdditionId: 0,
      radioButtonLength: false,
    };
  },
  computed: {
    ...mapGetters(["menu", "itemPrice"]),
    ...mapGetters([
      "language",
      "currency",
      "theme",
      "hasKiosk",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
      "menuHash",
      "minSelectedAdditionComboTotal",
      "minModifiersCheck",
    ]),
    ...mapGetters("Cart", ["comboDealAdditions"]),
    ...mapGetters("Theme", [
      "listsText",
      "listsBackground",
      "listsActiveText",
      "listsActiveBackground",
      "btnOutlineBorder",
      "btnOutlineText",
      "btnOutlineBackground",
      "btnOutlineIcon",
      "btnOutlineActiveBorder",
      "btnOutlineActiveText",
      "btnOutlineActiveBackground",
      "btnOutlineActiveIcon",
      "listActivePrice",
      "listActivePriceText",
      "selectItemColor",
      "kioskAdditionTitleLine",
      "listActivePriceBorder",
      "additionAddBackground",
      "kioskAdditionTitleColor",
    ]),
  },
  methods: {
    isAlreadySelected(addition) {
        return this.allSelectedModifiers.some(el=>{
          return el.Id==addition.Id&&el.combo_deal_item_id==addition.combo_deal_item_id;
        })
      },
    uncheck(event, id, price) {
      if (id != this.previeusAdditionId) {
        this.previeusAdditionId = id;
        this.previeusAdditionPrice = price;
      } else {
        this.previeusAdditionId = 0;
        this.previeusAdditionPrice = 0;
      }
    },
    selectModifier(modifierGroupId, price, id, data) {
      this.selectedComboModifiers = data.addition;
      if (data.addition.combo_deal_item_id) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: data.modifierGroup.AdditionGroupId,
            comboDealId: this.modifierGroup.combo_deal_item_id,
            selectedModifiers: this.selectedComboModifiers,
          });
        }, 100);
      } else {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: modifierGroupId,
            comboDealId: this.modifierGroup.combo_deal_item_id,
            selectedModifiers: this.selectedModifiers,
          });
        }, 100);
      }

    },
    giveComboDealId(index, groupIndex) {
      this.comboDealIndex = index;
      this.comboGroupDealIndex = groupIndex;
    },
    handleComboChange(currentValue) {
      let allmodifiers = this.modifier.Additions.map((x) => x.Id);
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .maxSelectedAmount == 1
      ) {
        // Get the current addition group on click
        const additions =
          document.querySelectorAll(`.allComboAdditions`)[this.groupIndex];
        // get all the additions with the additionPicture class in it
        const specificAdditions = additions.querySelectorAll(
          ".AdditionItemWrapper"
        );

        if (
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.contains("AdditionSelected")
        ) {
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.remove("AdditionSelected");
        } else {
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.add("AdditionSelected");
        }

        document.querySelectorAll(`.allComboAdditions`)[
          // eslint-disable-next-line no-use-before-define
          this.groupIndex
        ].classList.remove("required");

        specificAdditions.forEach((s) => {
          s.classList.add("AdditionItemWrapper--closed");
          s.classList.remove("AdditionItemWrapper--open");
        });

        // this returns all the current ID's from the additiongroup you click in
        if (this.minModifiersCheck.length) {
          // if the id's are not the same we know that its the first time we click on that addition group so we put that in the array so we can hold that data
          this.minModifiersCheck.map((x) => {
            if (x.id == this.modifier.AdditionGroupId) {
              x.minCount = 0;
            } else {
              if (this.modifier.minSelectedAmount != 0) {
                this.$store.commit("updateMinModifiersCheck", {
                  id: this.modifier.AdditionGroupId,
                  min: this.modifier.minSelectedAmount,
                  minCount: 0,
                  continue: false,
                });
                // we only want to store the same items 1 time in the array so we sort them out and store them
                this.$store.commit(
                  "transformMinModifiersCheck",
                  _.uniqBy(this.minModifiersCheck, "id")
                );
              }
            }
          });
        } else {
          if (this.modifier.minSelectedAmount != 0) {
            this.$store.commit("updateMinModifiersCheck", {
              id: this.modifier.AdditionGroupId,
              min: this.modifier.minSelectedAmount,
              minCount: 0,
              continue: false,
            });
          }
        }

        let objectId = { Id: this.selectedComboModifiers.Id };
        if (objectId?.Id)
          this.selectedModifiersArray = _.map(objectId, (item) => item);
        // return (this.selectedModifiersArray += this.selectedModifiers.Id);
      } else {
        this.selectedModifiersArray = _.map(
          this.selectedComboModifiers,
          function (item) {
            return item.Id;
          }
        );
      }

      /** Disable add to cart button disabled when minimum one modifers is allowed. */

      // if min 1 item needs to be selected
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .minSelectedAmount == 1
      ) {
        if (
          this.comboDealAdditions.data[this.comboGroupDealIndex]
            .maxSelectedAmount == 1
        ) {
          let radioBtnCurrentValue = [currentValue];
          if (
            radioBtnCurrentValue.length >=
            this.comboDealAdditions.data[this.comboGroupDealIndex]
              .minSelectedAmount
          ) {
            if (radioBtnCurrentValue[0].Id && !this.radioButtonLength) {
              //refactor this function in later stadium / this keeps the right number of selected MIN additions
            } else {
              this.radioButtonLength = false;
              if (
                this.selectedModifiersGroupIds.includes(
                  currentValue.AdditionGroupId
                ) ||
                !radioBtnCurrentValue[0].Id
              ) {
                this.$store.commit(
                  "updateMinSelectedAdditionComboTotal",
                  this.minSelectedAdditionComboTotal - 1
                );
              }

            }
            if (radioBtnCurrentValue[0].Id) {
              document.querySelectorAll(`.allComboAdditions`)[
                // eslint-disable-next-line no-use-before-define
                this.groupIndex
              ].classList.add("AdditionSelected");
              this.radioButtonLength = true;
              this.$store.commit(
                "updateMinSelectedAdditionComboTotal",
                this.minSelectedAdditionComboTotal + 1
              );
            }
            this.modifiersMessage = "";
          } else {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
          if (currentValue.length == 0) {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        } else {
          //updates the mincount in the array so we know how many additions we clicked
          currentValue.map((x) =>
            this.minModifiersCheck.map((y) => {
              if (y.id == x.AdditionGroupId) {
                y.minCount += 1;
              }
            })
          );
          if (currentValue.length && !this.radioButtonLength) {
            //refactor this function in later stadium / this keeps the right number of selected MIN additions
          } else {
            this.radioButtonLength = false;
          }
          if (currentValue.length) {
            this.radioButtonLength = true;
          }
          if (
            currentValue.length >=
            this.comboDealAdditions.data[this.comboGroupDealIndex]
              .minSelectedAmount
          ) {
            this.modifiersMessage = "";
          } else {
            // if not enough items are selected then block button
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        }
      }
      if (this.modifier.minSelectedAmount > 1) {
        if (
          this.minSelected == this.modifier.minSelectedAmount ||
          !this.minselectedbool
        ) {
          //refactor this function in later stadium / this keeps the right number of selected MIN additions
        }
        if (currentValue.length) {
          this.radioButtonLength = true;
          this.minSelected += 1;
        }
        let currentModifiers = this.selectedModifiersArray;
        let lengthModifiers = _.difference(
          allmodifiers,
          currentModifiers
        ).length;
        this.lengthModifiersDiff = allmodifiers.length - lengthModifiers;
        //updates the mincount in the array so we know how many additions we clicked
        currentValue.map((x) =>
          this.minModifiersCheck.map((y) => {
            if (y.id == x.AdditionGroupId) {
              y.minCount += 1;
            }
          })
        );
      }
      /** In Case when Unlimited Modifieres are allowed */
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .maxSelectedAmount == -1
      ) {
        this.$store.commit("updateModifierNumber", 0);
        this.modifiersMessage =
          this.lang["multiple_modifiers_can_be_selected"][this.language];
        return (this.disableModifiers = false), (this.disableBackground = "");
      }

      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .maxSelectedAmount == 1
      ) {
        this.$store.commit("updateModifierNumber", 1);
        /** When one modifier is selected then disable the further selection. */
        if (currentValue.length == 1) {
          this.modifiersMessage =
            this.lang["only_one_modifier_allowed"][this.language];
          this.disableBackground = "opacity-30";
          return (this.disableModifiers = true);
        } else {
          return (this.disableModifiers = false), (this.disableBackground = "");
        }
      }
      this.$store.commit("updateModifierNumber", 0);
      return (this.disableModifiers = false), (this.disableBackground = "");
    },
    handleChangeEmit() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedComboModifiers)
          ? this.selectedComboModifiers.map((d) => ({ Addition: d }))
          : { Addition: this.selectedComboModifiers },
      });
    },
  },
  watch: {
    selectedComboModifiers(currentValue) {
      //   this.handleChange();
      this.handleChangeEmit();
      this.handleComboChange(currentValue);
    },
  },
};
</script>

<style >
.required .requiredTitle {
  color: red;
  font-weight: bold;
}

.required.animated .requiredTitle {
  animation: 1.5s ease-out 0s 1 slideInFromLeft;
}

.borderNone:last-of-type div {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.borderNone:last-of-type .checked2,
.borderNone:last-of-type .checkedPrice {
  border-radius: 15px;
}
.input + .checked {
  transition: all 0.3s;
}
.input + .checked img {
  transition: all 0.3s;
}
.input:checked + .checked svg {
  transform: rotate(45deg);
}
.input:checked + div .checked2 {
  /* display: none; */
  transform: rotate(45deg);

}
.input:checked + div .checkedPrice svg{
  /* display: none; */
  transform: rotate(45deg);

}
.input:checked + .extra {
  border-radius: 2rem;
}
.borderNone:first-of-type .input:checked + .extra {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.borderNone:last-of-type .input:checked + .extra {
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
}
.borderNone:first-of-type .input:checked + div {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.borderNone:last-of-type .input:checked + div {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}


.input + div:hover {
  cursor: pointer;
}
</style>
